import { useState, useEffect } from 'react';

interface UseSearchQueryReturn {
  searchQuery: string;
  searchResultType: string | null;
  clearSearchQuery: () => void;
  setSearchQuery: (query: string) => void;
}

export const useSearchQuery = (): UseSearchQueryReturn => {
  const [searchQuery, setSearchQueryState] = useState<string>('');
  const [searchResultType, setSearchResultType] = useState<string | null>(null);
  const [hasReadFromStorage, setHasReadFromStorage] = useState(false);

  useEffect(() => {
    // Only read from sessionStorage once on mount
    if (hasReadFromStorage) {
      return;
    }
    
    // Check if there's a search query in sessionStorage
    const storedQuery = sessionStorage.getItem('searchQuery');
    const storedType = sessionStorage.getItem('searchResultType');
    
   // console.log('useSearchQuery - storedQuery:', storedQuery, 'storedType:', storedType);
    
    if (storedQuery) {
      //console.log('useSearchQuery - setting search query:', storedQuery, 'type:', storedType);
      setSearchQueryState(storedQuery);
      setSearchResultType(storedType);
      
      // Clear the stored query after retrieving it
      sessionStorage.removeItem('searchQuery');
      sessionStorage.removeItem('searchResultType');
    }
    
    setHasReadFromStorage(true);
  }, []); // Remove hasReadFromStorage from dependencies to ensure it only runs once

  const clearSearchQuery = () => {
    setSearchQueryState('');
    setSearchResultType(null);
  };

  const setSearchQuery = (query: string) => {
    setSearchQueryState(query);
  };

  return {
    searchQuery,
    searchResultType,
    clearSearchQuery,
    setSearchQuery
  };
}; 